export const emptyVinoForm = () => ({
    nombre: "",
    descripcion: "",
    tipo: "",
    nombre_en: "",
    descripcion_en: "",
    tipo_en: "",
});

export const vinoToForm = (vino) => ({
    nombre: vino?.nombre || "",
    descripcion: vino?.descripcion || "",
    tipo: vino?.tipo || "",
    nombre_en: vino?.nombre_en || "",
    descripcion_en: vino?.descripcion_en || "",
    tipo_en: vino?.tipo_en || "",
});
